import { rightMini } from "assets/icons";
import styled from "@emotion/styled";
import { Typography } from "antd";
import React, { FC } from "react";
import { ContactByIdResponse } from "services/interface";

interface AboutAgentProps {
  data: ContactByIdResponse | undefined;
}

const AboutAgent: FC<AboutAgentProps> = ({ data }) => {
  return (
    <>
      <ContentWrapper>
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
          ที่อยู่{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {data?.address} 
          </Typography.Text>
        </WrapperText>
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
          เบอร์โทรติดต่อฝ่ายขาย{" "}
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {data?.telephone_number}
          </Typography.Text>
        </WrapperText>
        <WrapperText>
          <Typography.Text style={{ color: "#A0A0A0" }}>
          ประเภทสินค้าที่ขาย
          </Typography.Text>
          <Typography.Text style={{ fontWeight: 400 }}>
            {data?.category}
          </Typography.Text>
        </WrapperText>

      </ContentWrapper>
    </>
  );
};

export default AboutAgent;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
`;

const WrapperText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 5px;
  width: 100%;
  height: 100%;
`;


